import { BaseModel } from "@blue-chip/core";
import Project from "./Project";

export default class Fee extends BaseModel {
  static get belongsTo() {
    return [Project];
  }
}
